import { createActionCreator } from '../../utils/helpers';

import { resendInvite } from './types';

export const requestResendInvite = createActionCreator(resendInvite.request, 'reportId');
export const requestResendInviteSuccess = createActionCreator(resendInvite.success);
export const requestResendInviteFailure = createActionCreator(resendInvite.failure);
